import ContentTypeField from '@/ecm/models/contentType/ContentTypeField'
export default class ContentType {
    constructor (dto) {
        this.id = 0
        this.name = ''
        this.minVersion = 0
        this.majVersion = 1
        this.version = 'v1.0'
        this.encryptDocuments = false
        this.keepActualVersion = false
        this.hasDocuments = false
        this.isLastVersion = false
        this.fields = []

        if (dto) {
            this.id = dto.Id
            this.name = dto.Name
            this.minVersion = dto.MinVersion
            this.majVersion = dto.MajVersion
            this.version = dto.Version
            this.encryptDocuments = dto.EncryptDocuments || false
            this.isLastVersion = dto.IsLastVersion
            this.hasDocuments = dto.HasDocuments
            this.fields = dto.DefFields.map(function (dto) { return new ContentTypeField(dto) })
        }
    }

    toDto () {
        var dto = {
            Id: this.id,
            Name: this.name,
            MinVersion: this.minVersion,
            MajVersion: this.majVersion,
            EncryptDocuments: this.encryptDocuments,
            KeepActualVersion: this.keepActualVersion,
            DefFields: [],
        }

        for (let i = 0; i < this.fields.length; i++) {
            const field = this.fields[i]
            field.order = i
            dto.DefFields.push(field.toDto())
        }

        return { ContentTypeStr: JSON.stringify(dto) }
    }
}
